const style = (theme): any => ({
    root: {
        display: 'flex',
        flex: 1,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
    /**
     * `contentSpacing` zeroes the top margin of every div sitting in a MuiBox,
     * and a tab panel wraps its children in one - so the blocks of a tab end up
     * glued to one another. Hand the margin back to all but the first, which is
     * the one that global rule is really after.
     */
    tabs: {
        '& .MuiBox-root > .LCRootViewEditBlock': {
            marginTop: `${theme.spacing(3)}px !important`,
        },
        '& .MuiBox-root > .LCRootViewEditBlock:first-child': {
            marginTop: '0 !important',
        },
    },
});
export default style;
